//local
export const API = 
//  "http://127.0.0.1:8000/api";

//local ip trabajo
//  "http://172.16.8.156:8000/api";

//Producción AWS
  "https://controlactivosback.skyangel.com.mx/api";

//Producción Azure
//  "https://controlactivosback.skyangel.mx/api";

// Puerto de desarrollo
export const PORT = 3006;

// Configuración adicional (DEPRECATED)
export const API_CONFIG = {
  timeout: 30000, // 30 segundos
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  }
};

// Configuración de Google Maps
export const GOOGLE_MAPS_CONFIG = {
  // API Key de Google Maps
  API_KEY: "AIzaSyBqA9FiNHwGGGGGGGGGGGGGGGGGGGGGGGG",
  
  // Configuración por defecto del mapa
  DEFAULT_CENTER: {
    lat: 19.4326, // Ciudad de México
    lng: -99.1332
  },
  
  DEFAULT_ZOOM: 12,
  
  // Opciones del mapa
  MAP_OPTIONS: {
    zoomControl: true,
    streetViewControl: true,
    mapTypeControl: true,
    fullscreenControl: true,
  }
};

// Estilos del mapa (opcional)
export const MAP_STYLES = [
  {
    featureType: "poi",
    elementType: "labels",
    stylers: [{ visibility: "off" }]
  }
];
